import { atom } from "jotai";

export const detalleIdAtom = atom();